import React from 'react';
import { classSet } from '@umu/umu-dom';
import { Iconfont as IconFont } from '@umu/umu-design';
import './index.scss';

export interface IProps {
    word: string;
    count?: number;
    iconType?: 'Complete';
    color?: string,
    wordColor?: string,
    borderColor?: string,
    countColor?: string,
    iconColor?: string,

    cls?: string;
}

/**
 * mobile端 使用 PopupSlidePicker
 * pc端 使用 TimePicker
 */
export default function Keyword({word, count, iconType, color, wordColor, borderColor, countColor, iconColor, cls}: IProps) {
    color = color || '#222222';

    wordColor = wordColor || color;
    countColor = countColor || wordColor;
    borderColor = borderColor || color;
    iconColor = iconColor || color;
    
    return (
        <span className={classSet('keyword-component', cls)} style={{'border': `1px solid ${borderColor}`}}>
            {iconType && <IconFont type={iconType} style={{color: iconColor}} className={`icon icon-${iconType}`} />}
            <span className="keyword" style={{color: wordColor}}>{word}</span>
            {count && <span className="count" style={{color: countColor}}>&nbsp;{'('}{count}{')'}</span>}
        </span>
    );
}
